import * as React from "react"
import { Col, Row } from "antd"
import { WeekTable } from "./WeekTable"
import { WeekInfo } from "./WeekInfo"
import "./cat.css"

export const CommunityTimeAllocator = () => {
    return (
        <div className="cat-wrapper">
            <Row gutter={[0, 16]}>
                <Col xs={24} xl={8}>
                    <WeekTable />
                </Col>
                <Col xs={24} xl={16}>
                    <WeekInfo />
                </Col>
            </Row>
        </div>
    )
}